import {handleActions} from 'redux-actions';
import {
    CONTENT_ITEM_SEARCHED_SET,
    CONTENT_ITEM_SEARCHED_RESET,
} from './ContentItemSearchAction';

const initialState = {
    data: null,
    isLoading: true,
};

export const setSearchedItem = (state: any, {payload}:any) => {
    if (payload)
        return {
            isLoading: false,
            data: payload,
        };
    
    return {
        ...state,
        isLoading: true,
    };
};

export const resetSearchedItem = () => {
    return initialState;
};

const handlers = {
    [CONTENT_ITEM_SEARCHED_SET]: setSearchedItem,
    [CONTENT_ITEM_SEARCHED_RESET]: resetSearchedItem,
};

export default handleActions(handlers, initialState);
